// المسار: src/Store.js
import React, { useState } from 'react';

const Store = ({ products, onAddToCart }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('الكل');
  const [selectedProduct, setSelectedProduct] = useState(null); // للمودال (التفاصيل)

  // استخراج الأقسام الموجودة تلقائياً من المنتجات
  const categories = ['الكل', ...new Set(products.map(p => p.category).filter(Boolean))];

  // عملية الفلترة والبحث
  const filteredProducts = products.filter(product => {
    const matchesSearch = product.name.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = selectedCategory === 'الكل' || product.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  return (
    <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
      
      {/* 1. أدوات التحكم (بحث + فلترة) */}
      <div style={{ marginBottom: '30px', textAlign: 'center' }}>
        <h2 style={{ fontSize: '28px', color: '#1e3a8a', marginBottom: '20px' }}>🛍️ المتجر الإلكتروني</h2>
        
        {/* شريط البحث */}
        <input 
          type="text" 
          placeholder="🔍 ابحث عن منتج (آيفون، شاحن...)" 
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ width: '100%', maxWidth: '400px', padding: '12px', borderRadius: '30px', border: '1px solid #ccc', fontSize: '16px', boxShadow: '0 4px 10px rgba(0,0,0,0.05)', outline: 'none' }}
        />

        {/* أزرار الفلترة */}
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '20px', flexWrap: 'wrap' }}>
          {categories.map(cat => (
            <button 
              key={cat}
              onClick={() => setSelectedCategory(cat)}
              style={{
                padding: '8px 20px', borderRadius: '20px', border: 'none', cursor: 'pointer',
                background: selectedCategory === cat ? '#2563eb' : '#e2e8f0',
                color: selectedCategory === cat ? 'white' : '#64748b',
                fontWeight: 'bold', transition: '0.3s'
              }}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>

      {/* 2. شبكة المنتجات */}
      {filteredProducts.length === 0 ? (
        <p style={{ textAlign: 'center', color: '#888' }}>لا توجد منتجات تطابق بحثك.</p>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '20px' }}>
          {filteredProducts.map(product => (
            <div 
              key={product.id} 
              style={{ background: 'white', borderRadius: '15px', padding: '15px', boxShadow: '0 5px 15px rgba(0,0,0,0.05)', transition: 'transform 0.3s', cursor: 'pointer', border: '1px solid #f1f5f9' }}
              onClick={() => setSelectedProduct(product)} // فتح التفاصيل
              onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              {/* الصورة */}
              <div style={{ height: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '10px', overflow: 'hidden', borderRadius: '10px' }}>
                {product.image && product.image.startsWith('data:') ? 
                  <img src={product.image} alt={product.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : 
                  <span style={{ fontSize: '60px' }}>{product.image}</span>
                }
              </div>
              
              <h3 style={{ fontSize: '18px', margin: '10px 0', color: '#1e293b' }}>{product.name}</h3>
              <p style={{ fontSize: '14px', color: '#64748b' }}>{product.category}</p>
              
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '15px' }}>
                <span style={{ fontWeight: 'bold', color: '#10b981', fontSize: '18px' }}>{product.price} DZD</span>
                <button 
                  onClick={(e) => { e.stopPropagation(); onAddToCart(product); }} // منع فتح المودال عند الضغط على الزر
                  style={{ background: '#2563eb', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '8px', cursor: 'pointer' }}
                >
                  + إضافة
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* 3. نافذة التفاصيل (Pop-up Modal) */}
      {selectedProduct && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000 }}>
          <div style={{ background: 'white', padding: '30px', borderRadius: '20px', maxWidth: '500px', width: '90%', position: 'relative', textAlign: 'center' }}>
            <button onClick={() => setSelectedProduct(null)} style={{ position: 'absolute', top: '10px', right: '10px', background: '#f1f5f9', border: 'none', borderRadius: '50%', width: '30px', height: '30px', cursor: 'pointer', fontWeight: 'bold' }}>×</button>
            
            <div style={{ height: '200px', marginBottom: '20px' }}>
               {selectedProduct.image && selectedProduct.image.startsWith('data:') ? 
                 <img src={selectedProduct.image} alt="" style={{ width: '100%', height: '100%', objectFit: 'contain' }} /> : 
                 <span style={{ fontSize: '80px' }}>{selectedProduct.image}</span>
               }
            </div>
            
            <h2 style={{ color: '#1e3a8a' }}>{selectedProduct.name}</h2>
            <p style={{ color: '#64748b', margin: '10px 0' }}>القسم: {selectedProduct.category}</p>
            <h3 style={{ color: '#10b981', fontSize: '28px', margin: '20px 0' }}>{selectedProduct.price} DZD</h3>
            
            <button 
              onClick={() => { onAddToCart(selectedProduct); setSelectedProduct(null); }}
              style={{ background: '#2563eb', color: 'white', border: 'none', padding: '12px 40px', borderRadius: '10px', fontSize: '18px', cursor: 'pointer', width: '100%' }}
            >
              أضف إلى السلة الآن 🛒
            </button>
          </div>
        </div>
      )}

    </div>
  );
};

export default Store;